import React, { useState } from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
// data
import PropertyTypeDataList from "./property-data.json";

export default function PropertyTypes() {
    const [PropertyTypeData] = useState(PropertyTypeDataList);
    return (
        <>
            <section className='section'>
                <Container>
                    <Row>
                        <Col md={12}>
                            <div className='section-title-box'>
                                <h1 className='section-title'><span className='text-primary'>Property</span> Types</h1>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="12">
                            <Swiper className='property-type-slider custom-slider pb-5'
                                spaceBetween={50}
                                pagination={{ dynamicBullets: true }}
                                modules={[Autoplay, Pagination]}
                                autoplay={{
                                    delay: 2500,
                                }}
                                breakpoints={{
                                    1: {
                                        slidesPerView: 1,
                                    },
                                    480: {
                                        slidesPerView: 2,
                                    },
                                    768: {
                                        slidesPerView: 3,
                                    },
                                    992: {
                                        slidesPerView: 4,
                                    },
                                    1200: {
                                        slidesPerView: 5,
                                    },
                                }}
                            >
                                {PropertyTypeData.propertyTypeList.map((data, i) =>
                                    <SwiperSlide key={i}>
                                        <div className='property-type-item text-center'>
                                            <div className='property-icon mx-auto mb-3'>
                                                <img src={require(`../../images/property-icon/${data.propertyIcon}`)} alt='' className='img-fluid' />
                                            </div>
                                            <h5>{data.categoryName}</h5>
                                            <Badge pill bg="light text-dark badge-lg overflow-auto">{data.categoryListing}</Badge>
                                        </div>
                                    </SwiperSlide>
                                )}
                            </Swiper>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
